import { render, staticRenderFns } from "./agr_general_settings.vue?vue&type=template&id=3eff305e&scoped=true&"
import script from "./agr_general_settings.vue?vue&type=script&lang=js&"
export * from "./agr_general_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff305e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eff305e')) {
      api.createRecord('3eff305e', component.options)
    } else {
      api.reload('3eff305e', component.options)
    }
    module.hot.accept("./agr_general_settings.vue?vue&type=template&id=3eff305e&scoped=true&", function () {
      api.rerender('3eff305e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/settings/tabs/agr_general_settings.vue"
export default component.exports